import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Privacy from "./Components/Privacy&Policy/index";
import TermsOf from "./Components/Pages/TermsOf/TermsOf";
import LandingPage from "./Components/LandingPage/LandingPage";
import EdofPage from "./Components/Pages/EdofPage/EdofPage";
import AboutUs from "./Components/Pages/AboutUs/AboutUs";
import ProfessionalsPage from "./Components/ProfessionalPage/ProfessionalsPage";
import ForPatients from "./Components/Pages/ForPatients/ForPatients";
import Sustainbility from "./Components/Pages/SustainbilityPage/Sustainbility";
import OurCompanyPage from "./Components/OurCompanyPage/OurCompanyPage";
import ContactUs from "./Components/ContactUs/ContactUs";
import LandingPage2 from "./Components/LandingPage2/LandingPage2";
import NewsRoomPage from "./Components/Pages/NewsRoomPage/NewsRoomPage";
import NotFound from "./Components/Pages/404page";
import NewsRoomPageNew from "./Components/Pages/NewsRoomPageNew/NewsRoomPageNew";
import NewsRoomPage2 from "./Components/Pages/NewsRoomPage2/NewsRoomPage2";
import BlogDetailPage from "./Components/Pages/BlogDetailPage/BlogDetailPage";

import EdofPageNew2 from "./Components/Pages/EdofPageNew2/EdofPageNew2";
import TopBar from "./Components/EdofSectionNew2/TopBar/TopBar";
import MedtechAwardPage from "./Components/Pages/MedtechAwardPage/MedtechAwardPage";
import PracticeAssessment from "./Components/PracticeAssessment/PracticeAssessment";
import Login from "./Components/Pages/Login/login";
import AdminDashboard from "./Components/Pages/Admin/AdminDashboard/AdminDashboard";
// import CalBooking from "./Components/Pages/CalBooking/CalBooking"; // restore with the booking route
import Navbar from "./Components/LandingPage/Navbar/Navbar";
import Footer2 from "./Components/Footer2/Footer2";
import PublicationHero from "./Components/Pages/ClinicalStudy/PublicationHero";
// import IFU from "./Components/Pages/IFU/IFU";
import IFU2 from "./Components/Pages/IFU2/IFU2";
// import IFU3 from "./Components/Pages/IFU3/IFU3";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// /admin is self-gating: no separate login route. Hitting /admin shows the
// (chrome-less) login form in place; after a successful admin login the same
// screen swaps to our Admin dashboard. Logout swaps it back to the form.
function AdminGate() {
  const readUser = () => {
    try {
      const raw = sessionStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };
  const [user, setUser] = useState(readUser);
  const isAdmin =
    !!user?.email &&
    (user.is_admin_panel === true || user.role_type === "Admin");

  if (isAdmin) {
    return (
      <>
        <ScrollToTop />
        <AdminDashboard onLogout={() => setUser(null)} />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Login embedded onSuccess={(u) => setUser(u)} />
    </>
  );
}

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <>
        <ScrollToTop />
        <NotFound />
      </>
    ),
  },
  // {
  //   path: "/",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <App />
  //     </>
  //   ),
  // },
  {
    path: "/privacy-and-cookie-policy",
    element: (
      <>
        <ScrollToTop />
        <Privacy />
      </>
    ),
  },
  {
    path: "/termsofuse",
    element: (
      <>
        <ScrollToTop />
        <TermsOf />
      </>
    ),
  },
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <LandingPage />
      </>
    ),
  },
  {
    path: "/landing-page2",
    element: (
      <>
        <ScrollToTop />
        <LandingPage2 />
      </>
    ),
  },

  {
    path: "/edof-old",
    element: (
      <>
        <ScrollToTop />
        <EdofPage />
      </>
    ),
  },

   
{
    path: "/edof",
    element: (
      <>
        <ScrollToTop />
        <EdofPageNew2/>
      </>
    ),
  },
  {
    path: "/deseyne-medtech-breakthrough-award-2026",
    element: (
      <>
        <ScrollToTop />
        <MedtechAwardPage/>
      </>
    ),
  },
  {
    path: "/practice_assessment",
    element: (
      <>
        <ScrollToTop />
        <PracticeAssessment />
      </>
    ),
  },
  // {
  //   path: "/academy-2026-anaheim",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <PracticeAssessment key="pa2-intro" variant="assessment2" />
  //     </>
  //   ),
  // },
  {
    path: "/academy-2026-anaheim/partner-with-us",
    element: (
      <>
        <ScrollToTop />
        <PracticeAssessment key="pa2-quiz" variant="assessment2" startAtQuiz />
      </>
    ),
  },
  // {
  //   path: "/ifu",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <TopBar />
  //       <Navbar />
  //       <IFU />
  //       <Footer2 />
  //     </>
  //   ),
  // },
  {
    path: "/ifu",
    element: (
      <>
        <ScrollToTop />
        <TopBar />
        <Navbar />
        <IFU2 />
        <Footer2 />
      </>
    ),
  },
  // {
  //   path: "/ifu3",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <TopBar />
  //       <Navbar />
  //       <IFU3 />
  //       <Footer2 />
  //     </>
  //   ),
  // },
  {
    path: "/deseyne-clinical-study",
    element: (
      <>
        <ScrollToTop />
        <TopBar />
        <Navbar />
        <PublicationHero />
        <Footer2 />
      </>
    ),
  },

{
    path: "/edof",
    element: (
      <>
        <ScrollToTop />
        <EdofPageNew2/>
      </>
    ),
  },

  // {
  //   path: "/fusion-technology",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <FusionTechnologyPage />
  //     </>
  //   ),
  // },
  {
    path: "/about-us",
    element: (
      <>
        <ScrollToTop />
        <AboutUs />
      </>
    ),
  },
  {
    path: "/news-room",
    element: (
      <>
        <ScrollToTop />
        <NewsRoomPage />
      </>
    ),
  },
  {
    path: "/newsroom",
    element: (
      <>
        <ScrollToTop />
        <NewsRoomPageNew />
      </>
    ),
  },
  {
    path: "/categories",
    element: (
      <>
        <ScrollToTop />
        <NewsRoomPage2 />
      </>
    ),
  },
  {
    path: "/blog-detail",
    element: (
      <>
        <ScrollToTop />
        <BlogDetailPage />
      </>
    ),
  },

  {
    path: "/for-professionals",
    element: (
      <>
        <ScrollToTop />
        <ProfessionalsPage />
      </>
    ),
  },
  {
    path: "/for-patients",
    element: (
      <>
        <ScrollToTop />
        <ForPatients />
      </>
    ),
  },
  {
    path: "/sustainability",
    element: (
      <>
        <ScrollToTop />
        <Sustainbility />
      </>
    ),
  },
  {
    path: "/our-company",
    element: (
      <>
        <ScrollToTop />
        <OurCompanyPage />
      </>
    ),
  },
  {
    path: "/contact-us",
    element: (
      <>
        <ScrollToTop />
        <ContactUs />
      </>
    ),
  },
  // Booking page disabled — the CTAs are commented out, so this route now
  // falls through to the "*" 404 route. Restore together with the CTAs.
  // {
  //   path: "/academy-2026-anaheim/book-fitting-slot",
  //   element: (
  //     <>
  //       <ScrollToTop />
  //       <TopBar />
  //       <Navbar compact />
  //       <CalBooking />
  //       <Footer2 />
  //     </>
  //   ),
  // },
  {
    path: "/admin",
    element: <AdminGate />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
  
    <RouterProvider router={router} />
  </React.StrictMode>,
);

reportWebVitals();